import { render, staticRenderFns } from "./MediaSummaryBox.vue?vue&type=template&id=a0f6104e&"
import script from "./MediaSummaryBox.vue?vue&type=script&lang=js&"
export * from "./MediaSummaryBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports